
export interface DataApiResponse<T> {
  data: T;
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
